import { useEffect } from "react";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { useSelector } from "react-redux";
import { RootState } from "~/shared/store/store";

/** Mount once (e.g., <App/>) — controls the top bar by network.inFlight */
export function TopLoader() {
  const inFlight = useSelector((s: RootState) => s.network.inFlight);

  useEffect(() => {
    NProgress.configure({
      showSpinner: false,
      trickleSpeed: 120,
      // minimum: 0.08,
    });
  }, []);

  useEffect(() => {
    if (inFlight > 0) NProgress.start();
    else NProgress.done();
  }, [inFlight]);

  return null;
}
